import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const ImageSettingsV1 = z.object({
  width: z.string(),
  height: z.string(),
  src: z.string(),
  style: z.string(),
})

export type TImageSettingsV1 = z.infer<typeof ImageSettingsV1>

export const ImageElementV1 = z.object({
  id: z.string(),
  name: z.literal("image"),
  settings: ImageSettingsV1,
  container: ContainerOptionsV1,
})

export type TImageElementV1 = z.infer<typeof ImageElementV1>

// Latest ---------------------
export const ImageSettings = ImageSettingsV1
export type TImageSettings = TImageSettingsV1
export const ImageElement = ImageElementV1
export type TImageElement = TImageElementV1
